/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleAUpIcon20Light = forwardRef('ArrowShapeTriangleAUpIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.12 14a1.1 1.1 0 0 1-.914-1.71L9.085 4.97a1.1 1.1 0 0 1 1.83 0l4.879 7.319a1.1 1.1 0 0 1-.915 1.71H5.12Zm-.082-1.156A.1.1 0 0 0 5.12 13h9.758a.1.1 0 0 0 .083-.156l-4.879-7.318a.1.1 0 0 0-.166 0l-4.88 7.318Z" })));
});
